import {SESSION_VARS} from "@/global/constants";

const KEY = SESSION_VARS.EXPIRED_DIALOG_SHOWN;

/**
 * Control de "una vez por sesión" del diálogo "Suscripción vencida".
 *
 * Usa localStorage (no sessionStorage, que es por pestaña) para que no se repita al abrir otra pestaña.
 * Cada inicio de sesión (usuario/clave u OAuth) llama a reset(), así una nueva sesión lo vuelve a mostrar.
 */
export default {
    wasShown: () => localStorage.getItem(KEY) === "true",
    markShown: () => localStorage.setItem(KEY, "true"),
    reset: () => localStorage.removeItem(KEY),
};
